module.exports = __webpack_public_path__ + "img/partner.a3ce50c.png";